module.exports = __webpack_public_path__ + "img/monthly.9c43106f.png";